import React, { Component } from "react";

import UserRow from "./UserRow";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import { makeStyles, withStyles } from '@material-ui/core/styles';

class UserList extends Component {
	

	constructor(props) {
        super(props);
		this.state= {
			page: 0,
			rowsPerPage: 25
		}
		
		this.handleFirstPageButtonClick=this.handleFirstPageButtonClick.bind(this);
		this.handleBackButtonClick=this.handleBackButtonClick.bind(this);
		this.handleNextButtonClick=this.handleNextButtonClick.bind(this);
		this.handleLastPageButtonClick=this.handleLastPageButtonClick.bind(this);
		this.handleChangePage=this.handleChangePage.bind(this);
		this.handleChangeRowsPerPage=this.handleChangeRowsPerPage.bind(this);
		this.orderUsers=this.orderUsers.bind(this);
		this.setSharedUsersView=this.setSharedUsersView.bind(this);
		this.switchUserState=this.switchUserState.bind(this);
		
    }
	
	handleFirstPageButtonClick(event) {
		this.setState({page: 0});
	}
	
	handleBackButtonClick(event) {
		this.setState({page: this.state.page-1});
	}
	
	handleNextButtonClick(event) {
		this.setState({page: (this.state.page+1 > Math.max(0, Math.ceil(Object.keys(this.props.users).length / this.state.rowsPerPage) - 1)) ? this.state.page : this.state.page+1});
	}
	
	handleLastPageButtonClick(event) {
		this.setState({page: Math.max(0, Math.ceil(Object.keys(this.props.users).length / this.state.rowsPerPage) - 1)});
	}
  
	handleChangePage(event, newPage) {
		this.setState({page: newPage});
	}
	
	handleChangeRowsPerPage(event) {
		this.setState({ rowsPerPage: parseInt(event.target.value, 10),
						page: 0
		});
	}
	
	switchUserState(userId, newState){
		//console.log(newState);
		this.props.switchUserState(this.props.users[userId], newState);
	}
	
	orderUsers(a, b){
		return this.props.users[a].username.localeCompare(this.props.users[b].username);
	}
	
	setSharedUsersView(id, list){
		this.props.setSharedUsersView(id, list);
	}

	render() {
//		console.log('render [UserList STATE]: ' + JSON.stringify(this.state));
//		console.log('render [UserList PROPS.users.length]: ' + JSON.stringify(this.props.users.length));
//		console.log(this.props);
		const rows = [];
		var customerName;
		var customerId;
		var user;
		var keys = [];
		if(this.props.users){
			keys = Object.keys(this.props.users).sort(this.orderUsers);
			//keys.sort(this.orderUsers);
			if(keys.length>0){
				for (var j = this.state.rowsPerPage*this.state.page; (j < (this.state.rowsPerPage*(this.state.page+1))) && (j<keys.length); j++) {
				//this.props.users.forEach((user) => {
					user = this.props.users[keys[j]];
					//customerName = (user.customer && Object.keys(this.props.customers).length>0 && typeof(this.props.customers[user.customer]) !== 'undefined')? this.props.customers[user.customer].name:"";
					customerName = (user.customer && this.props.customers[user.customer])? this.props.customers[user.customer].name:"";
					customerId = (user.customer)?user.customer:0;
					
					let activeUserList = [];
					if(typeof user.sharedUsersView !== 'undefined' && user.sharedUsersView!==null && user.sharedUsersView.length>0){
						activeUserList = user.sharedUsersView.split(",").map(Number);
					}
					
//					if(activeUserList.length>0){
//						console.log(keys);
//						console.log(activeUserList);
//						console.log(keys.map(Number).reduce((acc, cur) => { console.log(cur+":"+this.props.users[cur].username+":"+activeUserList.includes(cur)); return activeUserList.includes(cur) ? (acc + (acc.length>0 ? ", ":"") + this.props.users[cur].username) : acc;}, ""));
//					}
					
					rows.push(
					<UserRow
						key={user.id}
						id={user.id}
						username={user.username}
						fullname={user.firstName}
						role={user.role}
						customerName={customerName}
						customerId={customerId}
						enabled={user.enabled}
						sharedUsersView = {activeUserList}
						sharedUsersViewDescription = {keys.map(Number).reduce((acc, cur) => activeUserList.includes(cur) ? (acc + (acc.length>0 ? ", ":"") + this.props.users[cur].username) : acc, "")}
						relatedUsers = {this.props.relatedUsers}
						switchUserState = {this.switchUserState}
						setSharedUsersView = {this.setSharedUsersView}
						actions={this.props.userActions}/>
					);
				}
				//});
			}
		}
		return (
		<div className="content">
		  <table className="table table-striped table-hover lst">
		    <thead>
		      <tr>
		        <th>Id</th>
				<th>Username</th>
				<th>Full Name</th>
				<th>View users</th>
				<th>Role</th>
		        <th>Customer</th>
				<th>Actions</th>
		      </tr>
		    </thead>
		    <tbody>{rows}</tbody>
		    <tfoot>
              <tr>
                <TablePagination
                  colSpan={5}
                  count={keys.length}
                  rowsPerPage={this.state.rowsPerPage}
                  page={this.state.page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                />
              </tr>
            </tfoot>
		  </table>
		</div>
		);
  }
};

export default UserList;